import { render } from "./CouponLogs.vue?vue&type=template&id=b70d42b2&scoped=true&ts=true"
import script from "./CouponLogs.vue?vue&type=script&lang=ts"
export * from "./CouponLogs.vue?vue&type=script&lang=ts"

import "./CouponLogs.vue?vue&type=style&index=0&id=b70d42b2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70d42b2"]])

export default __exports__